import ReactPhoneNumberInput from 'react-phone-number-input'
import React, { ReactElement } from 'react'

import { InputProps } from '../Input'

// E164Number imported to react-phone-number-input from 'libphonenumber-js/core'.
// Define here to avoid installing a new package for one type.
type Tagged<A, T> = A & { __tag?: T }
type E164Number = Tagged<string, 'E164Number'>

export type PhoneProps = Omit<InputProps, 'value' | 'onChange'> & {
  country?: 'GB' | 'US'
  value?: E164Number
  onChange: (value?: E164Number) => void
}

export const PhoneInput = (props: PhoneProps): ReactElement => {
  const { country } = props

  return <ReactPhoneNumberInput defaultCountry={country} {...props} />
}
